<ng-container [ngSwitch]="actionType">
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.APPEND)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-append
      [fieldControl]="fieldControl"
    ></app-address-field-append>
  </div>
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.NULLIFY)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-nullify
      [fieldControl]="fieldControl"
      [checkBoxControl]="checkBoxControl"
    ></app-address-field-nullify>
  </div>
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.PREPEND)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-prepend
      [fieldControl]="fieldControl"
    ></app-address-field-prepend>
  </div>
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.REPLACE)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-replace
      [fieldControl]="fieldControl"
    ></app-address-field-replace>
  </div>
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.SUBSTITUTE)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-substitute
      [fieldControl]="fieldControl"
    ></app-address-field-substitute>
  </div>
  <div class="address-field-action"
       *ngSwitchCase="dataRulesService.actionOpName(actionOps.FORMAT)">
    <span class="material-icons notranslate">{{iconName}}</span>
    <h3>{{fieldLabel}}</h3>
    <app-address-field-format
      [fieldControl]="fieldControl"
    ></app-address-field-format>
  </div>
</ng-container>
